const asientoValidation = (mesTrabajo, mesAsiento) => {
  if (mesTrabajo > 12) {
    return false
  } else {
    if (mesTrabajo !== mesAsiento) {
      return true
    }
  }
}


export default Object.freeze({
  asientoValidation
})
